

import Component from 'generic.basecomponent';
import $ from 'jquery';
import createEvent from 'create-event';
import pageSpinner from 'page-spinner';

export default class CurrencySwitcher extends Component {
    constructor(el) {
        super(el);

        this.pseudoItemDataAttributeName = 'data-switcher-value';

        this.values = {
            Euro: { caption: '&euro; EUR', id: 'eu' },
            PoundSterling: { caption: '&pound; GBP', id: 'en' },
            UnitedStatesDollar: { caption: '$ USD', id: 'us' },
        };

        this.currentValue = null;
        this.isCustomPostback = this.container.hasAttribute('data-currency-switcher-custom-postback');
        this.init();
    }

    init() {
        this.pseudo = this.container.querySelector('.js-currency-switcher-pseudo');
        this.control = this.container.querySelector('.js-currency-switcher-control');
        this.nativeControlWrap = this.container.querySelector('.js-currency-switcher-select-wrap');

        if (this.nativeControlWrap) {
            this.customPostbackClientId = this.nativeControlWrap.getAttribute('data-clientid');
        }


        if (this.pseudo && this.control) {
            this.pseudoList = this.pseudo.querySelector('.js-currency-switcher-pseudo-list');
            this.pseudoValue = this.pseudo.querySelector('.js-currency-switcher-pseudo-value');


            this.controlInput = this.control.querySelector('select');

            this.setSwitcherValue(this.controlInput.value);
            this.renderPseudoList();

            this.pseudo.addEventListener('click', (e) => {
                e.stopPropagation();
                this.pseudo.classList.add('is-open');
            });
            this.pseudoList.addEventListener('click', this.onListClick.bind(this));

            document.addEventListener('click', () => {
                this.close();
            });
        }
    }

    close() {
        this.pseudo.classList.remove('is-open');
    }

    setSwitcherValue(value) {
        if (this.currentValue !== value) {
            this.currentValue = value;
            this.pseudoValue.innerHTML = this.getCaptionByValue(value);
            this.pseudo.setAttribute('data-currency-id', this.getIdByValue(value));
            return true;
        }
        return false;
    }

    onListClick(e) {
        e.stopPropagation();
        if (e.target) {
            const element = e.target;
            const value = element.getAttribute(this.pseudoItemDataAttributeName);
            if (value) {
                const isSet = this.setSwitcherValue(value);
                if (isSet) {
                    this.triggerEvent(value);
                    pageSpinner.show({ fade: true });
                }
                this.close();
            }
        }
    }

    renderPseudoList() {
        let listContent = '';


        Object.keys(this.values).forEach((value) => {
            listContent += `<span ${this.pseudoItemDataAttributeName}="${value}" class="currency-switcher__item">${this.getCaptionByValue(value)}</span>`;
        });

        this.pseudoList.innerHTML = listContent;
    }

    triggerEvent(value) {
        this.controlInput.value = value;
        if (this.isCustomPostback) {
            window.__doPostBack(this.customPostbackClientId, '');
        } else {
            this.controlInput.dispatchEvent(createEvent('change'));
        }
    }

    getCaptionByValue(value) {
        return this.values[value].caption;
    }

    getIdByValue(value) {
        return this.values[value].id;
    }
}



// WEBPACK FOOTER //
// ./app/components/currency-switcher/js/generic.currency-switcher.js